import React from 'react';
import Navbar from '../../../Navbar';
import Footer from '../../../Footer';
import Header from '../../../Header';

const Membership = () => {
  return (
    <div>
      <Navbar />
      {/* <Header /> */}
      <div style={{ height: "80vh" }}>
        <h4>Spero Membership</h4>
      </div>
      <Footer />
    </div>
  )
}

export default Membership
